import React, { useRef } from 'react';
import './style.css';
import diamondIcon from '../../assets/images/diamond-icon.svg';
import colorIcon from '../../assets/images/color-icon.svg';
import heyIcon from '../../assets/images/hey.svg';
import heyLogo from '../../assets/images/hey-logo.svg';
import libraryIcon from '../../assets/images/library.svg';
import instaIcon from '../../assets/images/insta-icon.svg';
import dribbleIcon from '../../assets/images/dribble-icon.svg';
import twitterIcon from '../../assets/images/twitter-icon.svg';
import { useEffect } from 'react';
import qedLogo from '../../assets/images/qed42_logo.svg';
import designLogo from '../../assets/images/qeddesign-logo.svg';
import spaceLogo from '../../assets/images/space-logo.svg';
import musicLogo from '../../assets/images/spotify-music-logo.svg';
import Heart from '../../assets/images/heart.svg';
import { TwitterShareButton} from 'react-twitter-embed';

import {gsap, ScrollTrigger, MotionPathPlugin } from 'gsap/all';


gsap.registerPlugin(ScrollTrigger);


const StoryFooter = () => {

  const mainSlide = useRef(null);
  const child1Slide = useRef(null);
  const child2Slide = useRef(null);

   useEffect(() => {
    // if(window.innerWidth>=769 ) {
     gsap.to(child1Slide.current,{
       yPercent: -100,
       ease: "none",
       stagger: 0.6,
       scrollTrigger: {
        trigger: mainSlide.current,
         start: "top top",
        end: "+=100%",
        // markers: true,
        // id:"my-footer",
         pin: true,
         scrub:true,
         pinSpacing: true
       }
     })
    // }
   }, []);
  


  return(
    
    <div className="story-footer-wrapper flex flex-col min-h-screen items-center w-full" ref={ mainSlide } id="container">
        {/* <section className="panel-footer w-full transform absolute"> */}
      <div className="story-footer-snap flex flex-col w-full items-center absolute"  ref={ child1Slide }>
        <div className="story-top-div w-10/12 pb-20 sm:pb-30 items-center flex flex-col">
              <h1 className="story-para w-5/6 pt-16 sm:pt-32 text-4xl sm:text-6xl text-center font-extrabold not-italic md:lh-4 md:leading-relaxed main-font">
                we're all same, we're all designers.
              </h1>
              {/* <h1 className="block sm:hidden story-para w-3/4 pt-16 sm:pt-32 text-3xl sm:text-6xl text-center font-bold not-italic md:lh-4 md:leading-relaxed main-font">
                
              </h1> */}
              {/* <h1 className="sm:block hidden story-para w-3/4 pt-16 sm:pt-32 text-3xl sm:text-6xl text-center font-bold not-italic md:lh-4 md:leading-relaxed main-font">
                we're all same, we're all designers.
              </h1> */}
              <a href="https://gum.co/kyoKZ" 
                className="story-btn font-extrabold py-3 px-3  items-center w-48 h-14 mt-10 text-center sm:w-48 interact-icon main-font"
              >
                DOWNLOAD
              </a>
              <div className="flex mt-8 sm:mt-10 flex-wrap options-para">
                <p className="story-free-comm w-full secondary-text text-center secondary-font story-free-comm">
                  Free for commercial or personal use.
                </p>
                <p className="story-free-comm w-full secondary-text text-center secondary-font story-free-comm">
                  Available For.
                </p>
            </div>

            <div className="flex flex-row items-center mt-4">
                <div className="story-icons rounded-full m-2 open-link" style={{backgroundImage: `url(${colorIcon})`}}>
                  <a href="https://gum.co/kyoKZ" className="story-icons-btn w-8 h-8 flex justify-center items-center open-link" aria-label="Figma Icon"></a>
                 </div>
                <div className="story-icons rounded-full m-2 open-link" style={{backgroundImage: `url(${diamondIcon})`}}>
                  <a href="https://gum.co/kyoKZ" className="story-icons-btn w-8 h-8 flex justify-center items-center open-link" aria-label="Sketch Icon"></a>
                 </div>
            </div>
            
            <div className="centerContent pt-2 w-full flex justify-center">
              <div className="inline-block" style={{width:'75px'}}>
              <TwitterShareButton 
                url="https://hey.qed42.com/"
                options={{
                  text:"Play with Hey! — A library of illustrations for everyone by @qed42",
                  size: 'large'
                }} 
                placeholder={<div style={{color:'black'}}>Loading...</div>}>
              </TwitterShareButton>
              </div>
            </div>
        </div>
        <div className="story-bottom-div flex flex-col sm:flex-row w-10/12 min-h-full justify-start sm:justify-between pt-4 sm:pt-0">
          <div className="justify-start h-24 sm:h-64 w-full sm:w-4/5 mt-4 sm:mt-12">
            <div className="relative flex img-div sm:w-5/6">
                <img className="image1-hey w-1/4 sm:w-1/5 main-font"  alt='logo' src={ heyLogo } width="640" height="360"  />
                {/* <img 
                  className="image2-hey absolute pt-8 pl-20 sm:pt-12 sm:pl-24" 
                  alt='logo' 
                  src={ libraryIcon } 
                /> */}
            </div>
            <div className="flex w-2/3 sm:w-1/6 absolute mt-4 sm:mt-32">
              <p className="flex footer-rights text-base font-light leading-3	non-italic secondary-font story-free-comm">© 2021 All Right Reserved</p>
            </div>
          </div>
          <div className="footer-content flex flex-col sm:flex-row w-full sm:w-4/5 h-64 sm:justify-start items-start sm:items-left pt-16 sm:pt-10 mb-10 sm:mb-0">
            <div className="hidden sm:w-1/4 h-32 sm:flex">

            </div>
            <div className="footer-content flex flex-col w-full sm:h-56 justify-start items-left sm:pt-0">
              <p className=" not-italic font-light text-base  w-full sm:w-4/5 secondary-font story-free-comm ">The “Hey” project is a largesse initiative</p>
              <p className=" not-italic font-light text-base  w-full sm:w-4/5 secondary-font story-free-comm ">for anyone who has to meet a deadline or</p>
              <p className=" not-italic font-light text-base  w-full sm:w-4/5 mb-2 sm:mb-4 secondary-font story-free-comm ">  just explore.</p>
              <p className=" not-italic font-light text-base  flex secondary-font story-free-comm ">Made with &nbsp; <img src={Heart} alt="heart"  width="15" height="360"/> &nbsp; by QED42.</p>
              <p className=" not-italic font-light text-base  w-full secondary-font story-free-comm ">Our first open-source design gig //</p>
              <p className=" not-italic font-light text-base  w-full secondary-font story-free-comm ">Illustrations by QED42 Design Team</p>
            <div className="footer-social-networking w-2/3 flex-row justify-start flex pt-6  lg:pt-12 mt-4">
              <div className="footer-logos w-1/6 h-5 open-link" >
                <a className="w-5 h-5 open-link" href="https://www.instagram.com/qed42.design/">
                  <img src={ instaIcon } alt='instagram' width="20" height="360"/>
                </a>
              </div>
              <div className="footer-logos w-1/6 h-5 open-link">
                <a className="w-5 h-5 open-link" href="https://dribbble.com/qed42">
                  <img src={ dribbleIcon } alt='dribble' width="20" height="360"/>
                </a>
              </div>
              <div className="footer-logos w-1/6 h-5 open-link">
                <a className="w-5 h-5 open-link " href="https://twitter.com/qed42">
                  <img src={ twitterIcon } alt='twitter' width="20" height="360"/>
                </a>
              </div>
            </div>
            </div>
          </div>
        </div>
        {/* <section className="panel-footer w-full transform absolute"> */}

        </div>
        {/* </section> */}

        <div className="end-footer w-full flex justify-evenly relative sm:absolute px-8 sm:px-24 h-full" ref={ child2Slide }>
          <div className="flex flex-col w-full justify-center items-center">
            <div className="end-footer-heading-container w-full flex justify-start items-start flex-col sm:pb-48">
              {/* <h2 className="end-footer-heading1 not-italic font-bold text-6xl ml-2 mt-12">This is not the end, beautiful friend</h2> */}
              <h2 className="end-footer-heading1 not-italic font-bold ml-2 sm:mt-40 main-font">This is not the end, beautiful friend</h2>
              {/* <h2 className="end-footer-heading2 not-italic font-bold ml-1">beautiful friend</h2> */}
            </div>
            
            <div className="flex flex-row flex-wrap sm:flex-no-wrap w-full justify-center sm:justify-start items-center pb-12">

                <div className="end-footer-design w-full sm:w-1/2 h-32 flex items-left flex-col justify-center mb-8 sm:mb-0">
                  <p className="secondary-font end-footer-para font-normal text-base sm:text-base not-italic w-4/5 sm:w-3/4">Our Design experiments and success stories.</p>
                  {/* <p className="secondary-font end-footer-para text-base not-italic">success stories.</p> */}
                  <div className="flex sm:mt-8 w-4/5 sm:w-3/4 h-12 sm:h-16 items-center open-link">
                    <a href="https://www.qed42.design/" className="open-link">
                      <img src={ designLogo } alt='QED42 design' width="170" height="360"/>
                    </a>
                  </div>
                </div>
                <div className="end-footer-about-company w-full sm:w-1/2 h-32 flex items-left flex-col justify-center mb-8 sm:mb-0">
                  <p className="secondary-font end-footer-para font-normal  text-base sm:text-base not-italic w-11/12 sm:w-3/4">A Full service open source company for web & mobile.</p>
                  {/* <p className="secondary-font end-footer-para text-sm not-italic">company for web & mobile.</p> */}
                  <div className="flex sm:mt-8 w-2/3 sm:w-3/4 h-12 sm:h-16 items-center open-link">
                    <a href="https://www.qed42.com/" className="open-link" >
                      <img src={ qedLogo } alt='QED42 logo' width="120" height="260"/>
                    </a>
                  </div>
                </div>
                <div className="end-footer-space w-full sm:w-1/2 h-32 flex items-left flex-col justify-center mb-8 sm:mb-0">
                  <p className="secondary-font end-footer-para font-normal  text-base sm:text-base not-italic w-4/5 sm:w-3/4">Imagine your website with SPACE Design System</p>
                  {/* <p className="secondary-font end-footer-para text-base not-italic">SPACE Design System</p> */}
                  <div className="flex mt- sm:mt-8 w-4/5 sm:w-3/4 h-12 sm:h-16 items-end sm:items-center">
                    <a href="http://" className="pointer-events-none">
                      <img src={ spaceLogo } alt='space design system' width="175" height="360"/>
                      {/* <p className=" sm:mt-4" style={{color: '#5b595f', marginTop: '2px'}}>coming soon...</p> */}
                    </a>
                  </div>
                </div>
                <div className="end-footer-music w-full sm:w-1/2 h-32 flex items-left flex-col justify-center mb-8 sm:mb-0">
                  <p className="secondary-font end-footer-para font-normal text-base sm:text-base not-italic w-4/5 sm:w-3/4">Stay tuned to our Design Podcast Designwise</p>
                  {/* <p className="secondary-font end-footer-para text-base not-italic">Podcast Designwise</p> */}
                  <div className="flex mt- sm:mt-8 w-4/5 sm:w-3/4 h-12 sm:h-16 items-end sm:items-center open-link">
                    <a href="https://open.spotify.com/show/0g0awQR8VDJESdKDhhfp6a" className="open-link">
                      <img src={ musicLogo } alt='QED42 spotify channel'  width="160" height="360"/>
                    </a>
                  </div>
                </div>
            </div>
          </div>
        </div>
        {/* </section> */}
    </div>

  )
}  

export default StoryFooter;